export enum BtnActionEnum {
    EXPORT = "export",
    GROUP = "group",
    CUSTOM = "custom",
    RAFRAICHIR  = " rafraichir",
    TRIE = "trie",
    SEARCH = "search"
}
